import { ProjectId } from 'api/models';
import { SpaceTab } from 'api/space';
import { MentionData } from 'components/molecules/mention';
import { useProjectSquad } from 'components/molecules/squad-picker/use-squad-options';
import { useProjectSpacesQuery } from 'queries';
import { useProjectTasksQuery } from 'queries/task';

interface MentionsDataOptions {
  enabled?: boolean;
}

export const useMentionsData = (
  projectId: ProjectId,
  options: MentionsDataOptions = {},
): Required<MentionData> => {
  const { data: members, isLoading: isMembersLoading } =
    useProjectSquad(projectId);

  const { data: tasks, isLoading: isTasksLoading } = useProjectTasksQuery(
    projectId,
    options,
  );

  const { isLoading: isSpacesLoading, data: spaces } = useProjectSpacesQuery(
    projectId,
    options,
  );

  const spaceTabs =
    spaces?.reduce((acc, space) => {
      acc.push(...space.spaceTabs);

      return acc;
    }, [] as SpaceTab[]) || [];

  return {
    members: {
      items: members,
      isLoading: isMembersLoading,
    },
    spaceTabs: {
      items: spaceTabs as SpaceTab[],
      isLoading: isSpacesLoading,
    },
    tasks: {
      items: tasks || [],
      isLoading: isTasksLoading,
    },
  };
};
